import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery: breakpoint } = mediaQueryStyles;

export const rootCss = {
  zIndex: 99,
};

export const modalContentWrapperCss = {
  [breakpoint.downTo(constants.breakpoints.BreakpointNames.sm)]: {
    height: "auto",
    maxWidth: "658px",
  },
};

export const unorderedListCss = {
  margin: 0,
  padding: 0,

  li: {
    listStyleType: "none",
  },
};

export const footerCss = {
  minHeight: "auto",

  [breakpoint.downTo(constants.breakpoints.BreakpointNames.sm)]: {
    display: "flex",
    justifyContent: "flex-end",
  },
};

export const closeButtonCss = {
  width: "100%",
  justifyContent: "center",

  [breakpoint.downTo(constants.breakpoints.BreakpointNames.sm)]: {
    width: "auto",
  },
};
